var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KTextbox',{attrs:{"label":"Number input","type":"number","value":2,"min":0,"max":100}})
}
var staticRenderFns = []

export { render, staticRenderFns }